import { render, staticRenderFns } from "./shipmentDetail.vue?vue&type=template&id=4bdfd395&scoped=true"
import script from "./shipmentDetail.vue?vue&type=script&lang=js"
export * from "./shipmentDetail.vue?vue&type=script&lang=js"
import style0 from "./shipmentDetail.vue?vue&type=style&index=0&id=4bdfd395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdfd395",
  null
  
)

export default component.exports